import React from 'react';
import CartForm from '../components/CartForm/CartForm';

const CartPage: React.FC = () => {
  return (
    <div className="cart-page page">
      <CartForm />
      <div className="blue-circle" />
      <div className="yellow-circle" />
    </div>
  );
};

export default CartPage;
